import React, { useState } from "react";
import styles from "./NewsletterBox.module.scss";
import Input from "./Input";
import Button from "./Button";
import Loader from "./three-dots.svg";

const fetchUrl =
  "https://ve87i5rml1.execute-api.eu-central-1.amazonaws.com/dev/blog-newsletter";

const NewsletterBox = () => {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const [successfulSubscribe, setSuccessfulSubscribe] = useState(false);

  const onSubmitHandler = e => {
    e.preventDefault();

    setIsFetching(true);

    fetch(fetchUrl, {
      method: "POST",
      body: JSON.stringify({
        email,
        name: name.length === 0 ? undefined : name
      })
    })
      .then(resp => {
        setSuccessfulSubscribe(true);
        setIsFetching(false);
      })
      .catch(err => {
        setIsFetching(false);
      });
  };

  if (successfulSubscribe) {
    return (
      <div className={styles.newsletterBox}>
        <h2>Now you are subscribed!</h2>
        <hr />
        <h3>Enjoy your day and staying on this site.</h3>
      </div>
    );
  }

  return (
    <form
      onSubmit={onSubmitHandler}
      className={styles.newsletterBox + " " + "text-white"}
    >
      <div className={styles.header}>
        <h2 className="text-3xl text-white">Join the Newsletter</h2>
      </div>
      <span>Name</span>
      <div className="text-gray-700" style={{ marginBottom: 15 }}>
        <Input
          value={name}
          onChange={e => setName(e.target.value)}
          style={{ width: "100%" }}
          placeholder="Name"
        />
      </div>
      <div>
        <span>E-Mail</span>
      </div>
      <div className="text-gray-700">
        <Input
          style={{ width: "100%", marginBottom: 30 }}
          placeholder="E-mail"
          value={email}
          onChange={e => setEmail(e.target.value)}
        />
      </div>
      <div>
        <Button
          type="submit"
          style={{
            width: "100%",
            height: 34,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {isFetching ? (
            <img height={14} src={Loader} style={{ marginBottom: 0 }} />
          ) : (
            "Subscribe"
          )}
        </Button>
      </div>
    </form>
  );
};

export { NewsletterBox };
